import { ABP, eLayoutType } from '@abp/ng.core';

export const CONFIRMACAO_ENTREGAS_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/faturamento/confirmacao-entregas',
    name: 'Confirmação de Entregas',
    parentName: 'Faturamento',
    iconClass: 'fas fa-clipboard-check',
    layout: eLayoutType.application,
    order: 1,
    requiredPolicy: 'cargo_fleet.ConfirmacaoEntregas',
  },
];
